(() => {
  const initialized = new WeakSet();
  const focusableSelector = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex="0"]';

  function initialize(root = document) {
    root.querySelectorAll('.newsletter-popup-section').forEach(section => {
      if (initialized.has(section)) return;
      const form = section.querySelector('.newsletter-popup-form');
      const dialog = section.querySelector('[role="dialog"]');
      const closeButton = section.querySelector('.close-popup');
      if (!form || !dialog || !closeButton) return;
      initialized.add(section);
      let previouslyFocused = null;
      let wasOpen = false;

      const isOpen = () => !section.classList.contains('closed');
      const close = () => section.classList.add('closed');
      const update = () => {
        const open = isOpen();
        form.inert = !open;
        dialog.setAttribute('aria-hidden', String(!open));
        if (open && !wasOpen) {
          previouslyFocused = document.activeElement;
          closeButton.focus({ preventScroll: true });
        } else if (!open && wasOpen && previouslyFocused?.isConnected) {
          previouslyFocused.focus({ preventScroll: true });
        }
        wasOpen = open;
      };

      closeButton.addEventListener('click', close);
      form.addEventListener('click', event => {
        if (event.target === form) close();
      });
      document.addEventListener('keydown', event => {
        if (!isOpen() || !section.isConnected) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const items = [...dialog.querySelectorAll(focusableSelector)].filter(element => element.getClientRects().length > 0);
        if (!items.length) {
          event.preventDefault();
          dialog.focus();
          return;
        }
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      document.addEventListener('focusin', event => {
        if (isOpen() && section.isConnected && !dialog.contains(event.target)) closeButton.focus({ preventScroll: true });
      });
      new MutationObserver(update).observe(section, { attributes: true, attributeFilter: ['class'] });
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
